import React from 'react';
import { actionIcons } from '../../../../../configs/Icons';
import ReloadButton from '../../../../features/ReloadButton/ReloadButton';
import InputField from '../../../../utils/InputField';

function ExternalLogPageHeaderMobile({ onChangeHandler, p, handleReload }) {
    return (
        <div className="mb-2.5">
            <div className="input-with-filter flex justify-between items-center">
                {/* Input Field */}
                <div className="input-box w-50 px-0.5 flex justify-start items-center border border-primary-200 rounded-lg bg-white">
                    <button type="button" className="size-[35px] min-w-max p-[7px] rounded-lg">
                        <img
                            src={actionIcons.searchW}
                            alt=""
                            className="w-full h-full object-cover"
                        />
                    </button>
                    <InputField
                        name="q"
                        placeholder="Search...."
                        formData={p}
                        onChange={onChangeHandler}
                        className="*:border-none *:h-full"
                    />
                </div>
                {/* Action Button */}
                <div className="button-list flex items-center gap-[5px]">
                    <ReloadButton
                        className="!size-[35px] focus:outline-none"
                        onClick={handleReload}
                    />
                </div>
            </div>
        </div>
    );
}
export default ExternalLogPageHeaderMobile;
